import React, { useState, FormEvent } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "../services/api";
import SearchIcon from "@mui/icons-material/Search";
import EmailIcon from "@mui/icons-material/Email";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./ForgotPasswordPage.css";

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitted(false);

    try {
      await publicApi.forgotPassword(email);
    } catch {
      // API always returns success for security; show same message regardless
    } finally {
      setIsSubmitting(false);
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="forgot-password-page">
        <div className="forgot-password-background">
          <div className="forgot-password-orb forgot-password-orb-1"></div>
          <div className="forgot-password-orb forgot-password-orb-2"></div>
          <div className="forgot-password-orb forgot-password-orb-3"></div>
        </div>

        <div className="forgot-password-container">
          <div className="forgot-password-card">
            <div className="forgot-password-header">
              <div className="forgot-password-logo">
                <SearchIcon className="forgot-password-logo-icon" sx={{ fontSize: 32 }} />
              </div>
              <h1>Check your email</h1>
              <p className="forgot-password-subtitle">
                If an account exists for that email, we&apos;ve sent password reset instructions.
              </p>
            </div>

            <div className="forgot-password-success">
              <CheckCircleIcon className="forgot-password-success-icon" fontSize="medium" />
              <p>Check your inbox and follow the link to reset your password.</p>
            </div>

            <div className="forgot-password-footer">
              <p className="forgot-password-link">
                <Link to="/login">Back to Sign In</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-background">
        <div className="forgot-password-orb forgot-password-orb-1"></div>
        <div className="forgot-password-orb forgot-password-orb-2"></div>
        <div className="forgot-password-orb forgot-password-orb-3"></div>
      </div>

      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="forgot-password-header">
            <div className="forgot-password-logo">
              <SearchIcon className="forgot-password-logo-icon" sx={{ fontSize: 32 }} />
            </div>
            <h1>Forgot Password</h1>
            <p className="forgot-password-subtitle">
              Enter your email and we&apos;ll send you a link to reset your password.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="forgot-password-form-group">
              <label htmlFor="email">Email</label>
              <div className="forgot-password-input-wrapper">
                <EmailIcon className="forgot-password-input-icon" fontSize="small" />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <button
              type="submit"
              className="forgot-password-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="forgot-password-button-spinner"></span>
                  Sending...
                </>
              ) : (
                "Send Reset Link"
              )}
            </button>
          </form>

          <div className="forgot-password-footer">
            <p className="forgot-password-link">
              <Link to="/login">Back to Sign In</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
